var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 9.7998V12.5998C20.9993 14.085 20.4093 15.5094 19.3591 16.5596C18.3089 17.6098 16.8845 18.1998 15.3993 18.1998H13.7585L11.2861 20.6736C11.6781 20.8822 12.1247 20.9998 12.5993 20.9998H15.3993L19.5993 25.1998V20.9998H22.3993C23.1419 20.9998 23.8541 20.7048 24.3792 20.1797C24.9043 19.6546 25.1993 18.9424 25.1993 18.1998V12.5998C25.1993 11.8572 24.9043 11.145 24.3792 10.6199C23.8541 10.0948 23.1419 9.7998 22.3993 9.7998H20.9993Z",
    fill: "#FFF6D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 7.0002C2.7998 6.25759 3.0948 5.5454 3.61991 5.0203C4.14501 4.49519 4.8572 4.2002 5.5998 4.2002H15.3998C16.1424 4.2002 16.8546 4.49519 17.3797 5.0203C17.9048 5.5454 18.1998 6.25759 18.1998 7.0002V12.6002C18.1998 13.3428 17.9048 14.055 17.3797 14.5801C16.8546 15.1052 16.1424 15.4002 15.3998 15.4002H12.5998L8.3998 19.6002V15.4002H5.5998C4.8572 15.4002 4.14501 15.1052 3.61991 14.5801C3.0948 14.055 2.7998 13.3428 2.7998 12.6002V7.0002Z",
    fill: "#FFD33D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSupport);
export default __webpack_public_path__ + "static/media/chat-support.0332c68c3ac840b94880ab3a58e6c1c6.svg";
export { ForwardRef as ReactComponent };